<template>
  <div class="sidebar d-flex flex-column p-3">
    <div class="sidebar-header mb-4">
      <h5 class="text-white text-center fw-bold">
        <i class="fas fa-bars me-2"></i>
        功能菜单
      </h5>
    </div>

    <div class="sidebar-content flex-grow-1">
      <!-- Basic Navigation -->
      <ul class="nav flex-column mb-4">
        <li class="nav-item">
          <RouterLink to="/" class="nav-link"
                :class="{ 'active': $route.path === '/' }">
            <i class="fas fa-tachometer-alt"></i>
            仪表板
          </RouterLink>
        </li>
      </ul>

      <!-- Customer Management -->
      <h6 class="sidebar-heading text-white-50 fw-bold text-uppercase mb-2">
        客户管理
      </h6>
      <ul class="nav flex-column mb-4">
        <li class="nav-item">
          <RouterLink to="/customers" class="nav-link"
                :class="{ 'active': $route.path.startsWith('/customers') && !customerCategory }">
            <i class="fas fa-users"></i>
            客户列表
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink to="/customers?category=案场" class="nav-link"
                :class="{ 'active': customerCategory === '案场' }">
            <i class="fas fa-user-tie"></i>
            案场客户
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink to="/customers?category=报备" class="nav-link"
                :class="{ 'active': customerCategory === '报备' }">
            <i class="fas fa-address-book"></i>
            报备客户
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink to="/customers?category=公共" class="nav-link"
                :class="{ 'active': customerCategory === '公共' }">
            <i class="fas fa-globe"></i>
            公共客户
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink to="/customers?category=无效" class="nav-link"
                :class="{ 'active': customerCategory === '无效' }">
            <i class="fas fa-times-circle"></i>
            无效客户
          </RouterLink>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link" href="/reports/overdue"
                :class="{ 'active': $route.path === '/reports/overdue' }">
            <i class="fas fa-exclamation-triangle"></i>
            逾期客户
          </a>
        </li> -->
      </ul>

      <!-- Property Management -->
      <h6 class="sidebar-heading text-white-50 fw-bold text-uppercase mb-2">
        房源管理
      </h6>
      <ul class="nav flex-column mb-4">
        <li class="nav-item">
          <RouterLink to="/properties" class="nav-link"
                :class="{ 'active': $route.path.startsWith('/properties') && $route.path !== '/properties/sales-control' }">
            <i class="fas fa-home"></i>
            房源列表
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink to="/properties/sales-control" class="nav-link"
                :class="{ 'active': $route.path === '/properties/sales-control' }">
            <i class="fas fa-chart-line"></i>
            销控表
          </RouterLink>
        </li>
      </ul>

      <!-- Transaction Management -->
      <h6 class="sidebar-heading text-white-50 fw-bold text-uppercase mb-2">
        交易管理
      </h6>
      <ul class="nav flex-column mb-4">
        <li class="nav-item">
          <RouterLink to="/transactions" class="nav-link"
                :class="{ 'active': $route.path.startsWith('/transactions') && !$route.path.includes('review') }">
            <i class="fas fa-file-contract"></i>
            收款交易列表
          </RouterLink>
        </li>
        <li v-if="isAdmin || isAssistant" class="nav-item">
          <RouterLink to="/transactions/review" class="nav-link"
                :class="{ 'active': $route.path === '/transactions/review' }">
            <i class="fas fa-check-circle"></i>
            交易审核
          </RouterLink>
        </li>
        <!-- <li v-if="isAdmin || isAssistant" class="nav-item">
          <RouterLink to="/transactions/stages" class="nav-link"
                :class="{ 'active': $route.path === '/transactions/stages' }">
            <i class="fas fa-list-ol"></i>
            交易阶段
          </RouterLink>
        </li> -->
      </ul>

      <!-- Reports and Analytics -->
      <!-- <h6 class="sidebar-heading text-white-50 fw-bold text-uppercase mb-2">
        报表分析
      </h6>
      <ul class="nav flex-column mb-4">
        <li class="nav-item">
          <RouterLink to="/reports" class="nav-link"
                :class="{ 'active': $route.path === '/reports' }">
            <i class="fas fa-chart-bar"></i>
            综合报表
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink to="/reports/customers" class="nav-link"
                :class="{ 'active': $route.path === '/reports/customers' }">
            <i class="fas fa-users"></i>
            客户统计
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink to="/reports/properties" class="nav-link"
                :class="{ 'active': $route.path === '/reports/properties' }">
            <i class="fas fa-home"></i>
            房源统计
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink to="/reports/transactions" class="nav-link"
                :class="{ 'active': $route.path === '/reports/transactions' }">
            <i class="fas fa-file-contract"></i>
            交易统计
          </RouterLink>
        </li>
      </ul> -->

      <!-- System Admin (Admin only) -->
      <div v-if="isAdmin" class="admin-section mb-4">
        <h6 class="sidebar-heading text-white-50 fw-bold text-uppercase mb-2">
          系统管理
        </h6>
        <ul class="nav flex-column mb-4">
          <li class="nav-item">
            <RouterLink to="/users" class="nav-link"
                  :class="{ 'active': $route.path === '/users' }">
              <i class="fas fa-user-cog"></i>
              用户管理
            </RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/agent-review" class="nav-link"
                  :class="{ 'active': $route.path === '/agent-review' }">
              <i class="fas fa-user-check"></i>
              经纪人审核
            </RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/job-management" class="nav-link"
                  :class="{ 'active': $route.path === '/job-management' }">
              <i class="fas fa-tasks"></i>
              定时任务管理
            </RouterLink>
          </li>
          <li v-if="isDemoUser" class="nav-item">
            <RouterLink to="/backup-management" class="nav-link"
                  :class="{ 'active': $route.path === '/backup-management' }">
              <i class="fas fa-database"></i>
              数据备份恢复
            </RouterLink>
          </li>
          <li v-if="isDemoUser" class="nav-item">
            <RouterLink to="/customer-status-preview" class="nav-link"
                  :class="{ 'active': $route.path === '/customer-status-preview' }">
              <i class="fas fa-user-clock"></i>
              客户状态预览
            </RouterLink>
          </li>
          <li v-if="isDemoUser" class="nav-item">
            <RouterLink to="/property-backup-management" class="nav-link"
                  :class="{ 'active': $route.path === '/property-backup-management' }">
              <i class="fas fa-home"></i>
              房源数据恢复
            </RouterLink>
          </li>
          <!-- <li class="nav-item">
            <RouterLink to="/settings" class="nav-link"
                  :class="{ 'active': $route.path === '/settings' }">
              <i class="fas fa-cog"></i>
              系统设置
            </RouterLink>
          </li> -->
        </ul>
      </div>

      <!-- 超级管理员专属（“演示用户”是历史命名，不是演示/只读账号） -->
      <div v-if="isDemoUser" class="demo-section mb-4">
        <h6 class="sidebar-heading text-white-50 fw-bold text-uppercase mb-2">
          安全性
        </h6>
        <ul class="nav flex-column mb-4">
          <li class="nav-item">
            <RouterLink to="/login-audit" class="nav-link"
                  :class="{ 'active': $route.path === '/login-audit' }">
              <i class="fas fa-shield-alt"></i>
              登录安全审计
            </RouterLink>
          </li>
        </ul>
      </div>
      <!-- <h6 v-if="isAdmin" class="sidebar-heading text-white-50 fw-bold text-uppercase mb-2">
        系统管理
      </h6>
      <ul v-if="isAdmin" class="nav flex-column mb-4">
        <li class="nav-item">
          <RouterLink to="/users" class="nav-link"
                :class="{ 'active': $route.path === '/users' }">
            <i class="fas fa-user-cog"></i>
            用户管理
          </RouterLink>
        </li>
        <li class="nav-item">
          <RouterLink to="/settings" class="nav-link"
                :class="{ 'active': $route.path === '/settings' }">
            <i class="fas fa-cog"></i>
            系统设置
          </RouterLink>
        </li>
      </ul> -->
    </div>

    <div class="sidebar-footer mt-auto">
      <hr class="text-white-50">
      <p class="text-white-50 text-center mb-0">
        <small>翼鸿房产营销管家 v1.0</small>
      </p>
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import logger from '@/utils/logger'

export default {
  name: 'SidebarComponent',
  setup() {
    const store = useStore()
    const route = useRoute()

    const isAdmin = computed(() => store.getters['auth/isAdmin'])
    const isSales = computed(() => store.getters['auth/isSales'])
    const isAssistant = computed(() => store.getters['auth/isAssistant'])

    // 超级管理员标识（“演示用户”是历史命名）：demonstration_user 白名单
    // 中的账号拥有备份恢复、登录安全审计等最高权限，不是演示/只读账号。
    const isDemoUser = ref(false)

    // 检查当前用户是否为超级管理员（沿用 can-switch-role 接口）
    const checkDemoUser = async () => {
      try {
        const token = localStorage.getItem('access_token')
        if (!token) {
          isDemoUser.value = false
          return
        }
        const response = await fetch('/api/users/can-switch-role', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        const result = await response.json()
        isDemoUser.value = result.can_switch || false
      } catch (error) {
        logger.error('Error checking demonstration user:', error)
        isDemoUser.value = false
      }
    }

    // 计算当前激活的客户分类菜单
    const customerCategory = computed(() => {
      // 从 URL 查询参数中获取 category
      return route.query.category
    })

    onMounted(() => {
      checkDemoUser()
    })

    return {
      isAdmin,
      isSales,
      isAssistant,
      isDemoUser,
      customerCategory
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  width: 250px;
  background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%);
  min-height: calc(100vh - 56px);
  position: sticky;
  top: 0;
  flex-shrink: 0;
}

.sidebar-heading {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  padding-left: 1rem;
  opacity: 0.8;
}

.nav-link {
  color: rgba(255, 255, 255, 0.8);
  padding: 0.75rem 1rem;
  text-decoration: none;
  transition: all 0.3s ease;
  border-radius: 0.375rem;
  margin-bottom: 0.25rem;

  i {
    width: 16px;
    margin-right: 0.75rem;
    text-align: center;
  }

  &:hover {
    color: white;
    background-color: rgba(255, 255, 255, 0.1);
    transform: translateX(4px);
  }

  &.active {
    color: white;
    background-color: rgba(255, 255, 255, 0.15);
    font-weight: 500;
    transform: translateX(8px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.sidebar-footer {
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.8rem;
}

@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    top: 56px;
    left: 0;
    z-index: 1050;
    width: 250px;
    height: calc(100vh - 56px);
    transform: translateX(-250px);
    transition: transform 0.3s ease;
  }
}
</style>